import PropTypes from 'prop-types';
import colorsPropTypes from '../utils/colors';
var propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(colorsPropTypes),
  customStyle: PropTypes.shape({}),
  disabled: PropTypes.bool,
  display: PropTypes.oneOf(['block', 'inline-block', 'none']),
  filled: PropTypes.bool,
  focusable: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.number
};
export default propTypes;